import { CognitoUser, ICognitoUserAttributeData } from 'amazon-cognito-identity-js';
import { AuthAction, CognitoError, SetAttributesRes } from './types';
import { wrapError } from '.';

/**
 * Set attributes for current user
 *
 * @param dispatch - reference to the auth state reducer dispatch method
 * @param cognitoUser - the current session user
 * @param attributes - the attributes to be updated
 * @returns
 */
export const cognitoSetAttributes = async (
  dispatch: React.Dispatch<AuthAction>,
  cognitoUser: CognitoUser,
  attributes: ICognitoUserAttributeData[],
): Promise<SetAttributesRes> => {
  return new Promise((resolve, reject) => {
    const fallbackErrMessage = 'Error occurred while setting attribute(s)';
    try {
      cognitoUser.updateAttributes(attributes, (err: Error | undefined, result: string | undefined) => {
        if (err) {
          const cognitoErr = err as CognitoError;
          dispatch({ type: 'setFeedback', payload: `${cognitoErr.message} (${cognitoErr.code})` });
          return reject({
            complete: false,
            result: result,
            error: wrapError(cognitoErr, fallbackErrMessage),
            message: 'Error: occurred while setting attribute(s)',
          });
        }
        dispatch({ type: 'setFeedback', payload: `attributes set: ${JSON.stringify(result)}` });
        return resolve({
          complete: true,
          result: result,
          error: undefined,
          message: 'Success: attribute(s) updated',
        });
      });
    } catch (err: unknown) {
      const error = err as Error;
      dispatch({ type: 'setFeedback', payload: error.message });
      return reject({
        complete: false,
        error: wrapError(error, fallbackErrMessage),
        message: 'Error: unable to set attribute(s)',
      });
    }
  });
};
